var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payInfo"},[_c('QS-h4-title',{attrs:{"title":"银行账户信息"}}),_vm._v(" "),_c('QS-column-box',{attrs:{"source":_vm.source,"list":_vm.list,"column":3,"labelWidth":"150","separator":":"}},[_c('template',{slot:"bankPic"},[_c('EnlargeImg',{staticClass:"avatar",attrs:{"imgSrc":_vm.source.bankPic||''}})],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }